import { useState } from 'react';

/**
 * Floating version badge — sits in the bottom-right corner.
 * Shows compact "v1.0.0" pill; expands on hover/click to show full build details.
 */
export function VersionBadge() {
  const [expanded, setExpanded] = useState(false);

  const version = __APP_VERSION__;
  const sha = __BUILD_SHA__;
  const buildTime = __BUILD_TIME__;

  const formattedTime = buildTime
    ? new Date(buildTime).toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : null;

  return (
    <div className="fixed bottom-3 right-3 z-50">
      {/* Expanded panel */}
      {expanded && (
        <div
          className="absolute bottom-full right-0 mb-2 w-56 rounded-lg shadow-lg border text-xs
            bg-white dark:bg-grey-800 border-grey-200 dark:border-grey-600
            p-3 space-y-1.5 animate-in fade-in slide-in-from-bottom-2 duration-150"
          onMouseEnter={() => setExpanded(true)}
          onMouseLeave={() => setExpanded(false)}
        >
          <div className="flex items-center justify-between">
            <span className="font-semibold text-charcoalGray-800 dark:text-white">Halo</span>
            <span className="font-mono text-primary-500">v{version}</span>
          </div>
          <div className="border-t border-grey-100 dark:border-grey-600 pt-1.5 space-y-1 text-charcoalGray-400 dark:text-charcoalGray-300">
            <div className="flex justify-between">
              <span>Commit</span>
              <span className="font-mono text-charcoalGray-600 dark:text-charcoalGray-200">
                {sha.slice(0, 8)}
              </span>
            </div>
            {formattedTime && (
              <div className="flex justify-between">
                <span>Built</span>
                <span className="text-charcoalGray-600 dark:text-charcoalGray-200">{formattedTime}</span>
              </div>
            )}
            <div className="flex justify-between">
              <span>Environment</span>
              <span className="text-charcoalGray-600 dark:text-charcoalGray-200">
                {import.meta.env.VITE_ENV || 'development'}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Compact pill  */}
      <button
        onClick={() => setExpanded(prev => !prev)}
        onMouseEnter={() => setExpanded(true)}
        onMouseLeave={() => setExpanded(false)}
        className="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-mono
          bg-grey-100 dark:bg-grey-800 text-charcoalGray-400 dark:text-charcoalGray-300
          border border-grey-200 dark:border-grey-600
          hover:bg-grey-200 dark:hover:bg-grey-700 transition-colors
          shadow-sm cursor-default select-none"
      >
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-emerald-400" />
        v{version}
      </button>
    </div>
  );
}
